import { natGenAccordionAnchorDefinition } from './components/accordion-anchor/accordion-anchor';
import { natGenAccordionItemDefinition } from './components/accordion-item/accordion-item';
import { natGenAccordionDefinition } from './components/accordion/accordion';
import { natGenAnchorDefinition } from './components/anchor/anchor';
import { natGenButtonDefinition } from './components/button/button';
import { natGenCardDefinition } from './components/card/card';
import { natGenCheckboxCardDefinition } from './components/checkbox-card/checkbox-card';
import { natGenCheckboxDefinition } from './components/checkbox/checkbox';
import { natGenComboboxDefinition } from './components/combobox/combobox';
import { natGenDesignSystemProviderDefinition } from './components/design-system-provider/design-system-provider';
import { natGenDialogDefinition } from './components/dialog/dialog';
import { natgenFlagDefinition } from './components/flag/flag';
import { natGenHamburgerButtonDefinition } from './components/hamburger-button/hamburger-button';
import { natGenIconDefinition } from './components/icon/icon';
import { natGenLoaderDefinition } from './components/loader/loader';
import { natGenLogoDefinition } from './components/logo/logo';
import { natGenOptionDefinition } from './components/option/option';
import { natGenPaletteDefinition } from './components/palette/palette';
import { natGenPopperDefinition } from './components/popper/popper';
import { natGenPortalDefinition } from './components/portal/portal';
import { natGenPortalOutletDefinition } from './components/portal/portal-outlet';
import { natGenProgressBarDefinition } from './components/progress-bar/progress-bar';
import { natGenRadioCardDefinition } from './components/radio-card/radio-card';
import { natGenRadioGroupDefinition } from './components/radio-group/radio-group';
import { natGenRadioDefinition } from './components/radio/radio';
import { natGenSelectDefinition } from './components/select/select';
import { natGenSideBarDefinition } from './layouts/side-bar/side-bar';
import { natGenSwitchDefinition } from './components/switch/switch';
import { natGenTextFieldDefinition } from './components/text-field/text-field';
import { natGenTokenValueDefinition } from './components/token-value/token-value';
import { natGenTooltipDefinition } from './components/tooltip/tooltip';
import { natGenWizardStepDefinition } from './components/wizard-stepper/wizard-step';
import { natGenWizardStepperDefinition } from './components/wizard-stepper/wizard-stepper';
import { DesignToken } from './foundation/design-token';
import { natgGenContainerDefinition } from './layouts/container/container';
import { natGenFormFieldDefinition } from './layouts/form-field/form-field';
import { natGenFormDefinition } from './layouts/form/form';
import { natGenNavbarDefinition } from './layouts/nav-bar/nav-bar';
import { natGenStackDefinition } from './layouts/stack/stack';
import { NatGenDesignSystem } from './natgen-design-system';

export * from './design-tokens';

// TODO: Better way to do this?
export * from './data/countries';

NatGenDesignSystem.registerAll([
    natGenAccordionDefinition,
    natGenAccordionItemDefinition,
    natGenAccordionAnchorDefinition,
    natGenAnchorDefinition,
    natGenButtonDefinition,
    natGenCardDefinition,
    natGenCheckboxDefinition,
    natGenCheckboxCardDefinition,
    natGenComboboxDefinition,
    natgGenContainerDefinition,
    natGenDesignSystemProviderDefinition,
    natGenDialogDefinition,
    natgenFlagDefinition,
    natGenFormDefinition,
    natGenFormFieldDefinition,
    natGenHamburgerButtonDefinition,
    natGenIconDefinition,
    natGenLoaderDefinition,
    natGenLogoDefinition,
    natGenNavbarDefinition,
    natGenOptionDefinition,
    natGenPaletteDefinition,
    natGenPopperDefinition,
    natGenPortalDefinition,
    natGenPortalOutletDefinition,
    natGenProgressBarDefinition,
    natGenRadioDefinition,
    natGenRadioCardDefinition,
    natGenRadioGroupDefinition,
    natGenSelectDefinition,
    natGenSideBarDefinition,
    natGenStackDefinition,
    natGenSwitchDefinition,
    natGenTextFieldDefinition,
    natGenTokenValueDefinition,
    natGenTooltipDefinition,
    natGenWizardStepDefinition,
    natGenWizardStepperDefinition
]);

DesignToken.registerDefaultStyleTarget(document);
